<div [class.bright]="isBright" class="main_content lite_view">
    <div class="selection_pg_main_sec">
        <div class="page_main_sec">
            <div class="dashboard_main_sec">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="dashboard-stats">
                            <div class="post-nav-wrap">
                                <div class="title-wrap">
                                    <p class="title semi-bold">Work Item</p>
                                </div>
                                <div class="work-item-btn-wrp">
                                    <a *ngFor="let worklist of lstWorkList" class="work-item-btn"
                                        [class.active]="selectedWorklistId==worklist.worklist_id"
                                        (click)="onSelectWorkList(worklist)">
                                        {{worklist.worklist_text}} <span
                                            class="work-item-count">{{worklist.worklist_count}}</span></a>
                                </div>
                                <div class="search-box top-search" *ngIf="isDisplaySearchBox">
                                    <img src="../../../assets/img/search.png" alt="search">
                                    <input type="search" [(ngModel)]="searchURN" (search)="clearSearch()"
                                        autocomplete="off" class="search-input" placeholder="URN">
                                    <span class="search-button search-data" (click)="searchWorkItems()">
                                        <i class="material-icons">search</i></span>
                                </div>
                                <ul class="nav top-actions">
                                    <li>
                                        <a (click)="onIconSearchClick()" class="search-icon">
                                            <i class="material-icons">search</i>
                                        </a>
                                    </li>
                                    <li>
                                        <a (click)="showFilterModel()" title="Filteration Options">
                                            <i class="material-icons theme-text-color">filter_list</i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <!-- <div class="stats-bx-wrap">
                                <div class="stats-bx" (click)="activeWorkList='Pending Approval';getWorkItems()">
                                    <div class="left-icn">
                                        <img src="../../../assets/img/icons/pending_approval.png" alt="All Ticket"
                                            class="img-fluid" title="Pending Approval">
                                    </div>
                                    <div class="right-cont">
                                        <p class="stat-title" title="Overall URN Count">Pending Approval</p>
                                        <p class="stat-count semi-bold">{{statistics.pending_approval}}</p>
                                    </div>
                                </div>
                                <div class="stats-bx" (click)="activeWorkList='Pending Query';getWorkItems()">
                                    <div class="left-icn">
                                        <img src="../../../assets/img/icons/pending.png" alt="All Ticket"
                                            class="img-fluid" title="Pending Query">
                                    </div>
                                    <div class="right-cont">
                                        <p class="stat-title" title="Overall URN Count">Pending Query</p>
                                        <p class="stat-count semi-bold">{{statistics.pending_query}}</p>
                                    </div>
                                </div>
                                <div class="stats-bx" (click)="activeWorkList='Forward';getWorkItems()">
                                    <div class="left-icn">
                                        <img src="../../../assets/img/icons/URN.png" alt="All Ticket" class="img-fluid"
                                            title="Forward">
                                    </div>
                                    <div class="right-cont">
                                        <p class="stat-title" title="Overall URN Count">Forward</p>
                                        <p class="stat-count semi-bold">{{statistics.pending}}</p>
                                    </div>
                                </div>
                                <div class="stats-bx" (click)="activeWorkList='Proxy/Delegate';getWorkItems()">
                                    <div class="left-icn">
                                        <img src="../../../assets/img/icons/open.png" alt="All Ticket" class="img-fluid"
                                            title="Proxy/Delegate">
                                    </div>
                                    <div class="right-cont">
                                        <p class="stat-title" title="Overall URN Count">Proxy/Delegate</p>
                                        <p class="stat-count semi-bold">{{statistics.percent_of_close}}</p>
                                    </div>
                                </div>
                            </div> -->

                            <!-- Pagination Top -->
                            <!-- <div class="dataTables_paginate paging_simple_numbers" id="example_paginate">
                                <div class="paginate_left_sec">
                                    <div class="dataTables_info" id="example_info" role="status" aria-live="polite">
                                        Showing {{firstRecord}} to {{lastRecord}} of {{this.lstTransaction.length}}
                                        entries
                                        <span> | Records Per Page
                                            <a [matMenuTriggerFor]="recordsPerPageMenu"
                                                class="record_per_page_trigger">{{recordsPerPage}}</a></span>
                                        
                                    </div>
                                </div>
                                <div class="paginate_right_sec">

                                    <a class="paginate_button previous disabled" aria-controls="example" data-dt-idx="0"
                                        tabindex="0" id="example_previous" (click)="changePage('prev',0)">
                                        <i class="material-icons">chevron_left</i>
                                    </a>
                                    <span>
                                        <a *ngFor="let pg of lstTotalPage;let i=index;" class="paginate_button"
                                            [class.current]="currentPage==(i+1)" aria-controls="example" data-dt-idx="1"
                                            tabindex="0" (click)="changePage('',(i+1))">{{i+1}}</a>
                                    </span>
                                    <a class="paginate_button next" aria-controls="example" data-dt-idx="4" tabindex="0"
                                        id="example_next" (click)="changePage('next',0)">
                                        <i class="material-icons">chevron_right</i>
                                    </a>
                                </div>
                            </div> -->

                            <!-- Main Table -->
                            <div class="mail-box-body-wrap">
                                <div class="infobarWrapper" *ngFor="let item of lstTransaction;let rowIndex=index">
                                    <div class="infoBarWrapDrop">
                                        <div class="titleSection">
                                            <div class="actionButton">
                                                <div class="infoBar infoBarEdit">
                                                    <a href="javascript:void(0)"
                                                        (click)="openTransactionModal(item.DOCUMENT_DETAIL_ID)"><i
                                                            class="bi bi-pencil-fill" title="Edit"></i></a>
                                                    <div class="infoBarCol dropdown dropdownborder">
                                                        <button class="moreIcon"
                                                            (click)="showHideMoreInfo(item.DOCUMENT_DETAIL_ID)">
                                                            <i class="indicator bi bi-chevron-down"
                                                                [class.active]="showMoreInfoDocumentIDs.includes(item.DOCUMENT_DETAIL_ID)"></i></button>
                                                    </div>
                                                </div>
                                                <div class="infoBar infoTitlewrap">
                                                    <span class="infoTitle infoTitleBuyer"
                                                        (click)="openTransactionModal(item.DOCUMENT_DETAIL_ID)"><a
                                                            href="javascript:void(0)">{{item.URN}}</a></span>
                                                    <p class="infoBarp"><span title="Source">{{item.SOURCE}}</span> |
                                                        <span title="Work Item Type">{{item['Work Item Type']}}</span>
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="actionDetails infoTitlewrap">
                                                <!-- <div class="infoBar centerTxt infoBarCenter">
                                                    <span class="infoTitle " title="Invoice Amount">$232mn</span>
                                                </div> -->
                                                <div class="infoBar infoBarLeft">
                                                    <span class="infoT">Created On</span>
                                                    <span class="infoTitleN" title="Invoice Date"><i
                                                            class="bi bi-calendar"></i> {{item['Created Date']}}</span>
                                                </div>
                                                <div class="infoBar infoBarLeft">
                                                    <span class="infoT">Assigned Date</span>
                                                    <span class="infoTitleN" title="Invoice Date"><i
                                                            class="bi bi-calendar"></i> {{item['Assigned Date']}}</span>
                                                </div>
                                                <div class="infoBar infoBarLeft">
                                                    <span class="infoT" title="Pending With">{{item['Pending
                                                        With']}}</span>
                                                    <span class="infoTitleN" title="Queue"><i
                                                            class="bi bi-hourglass"></i> {{item.Queue}}</span>
                                                </div>

                                                <div class="infoBar infoBarCenter infoBuyerStatus">
                                                    <span class="buyerApproval">{{item['Work List']}}</span>
                                                    <span class="infoTitleN" title="Pending Since">since {{item['Pending
                                                        Since (Days)']}} days</span>
                                                </div>
                                                <div class="infoBar infoBarStatus">
                                                    <span (click)="commonService.openAttachment(item.URN,'')"><i
                                                            class="bi bi-download" title="Download"></i></span>
                                                    <span><i class="bi bi-flag-fill"
                                                            [class.green]="item.Priority=='NORMAL'"
                                                            [class.red]="item.Priority=='HIGH'" title="Priority"></i>
                                                    </span>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div *ngIf="showMoreInfoDocumentIDs.includes(item.DOCUMENT_DETAIL_ID)"
                                        class="infoBarWrapDrop Showmoreinfo headingOne">
                                        <div class="row">
                                            <ng-container *ngFor="let sub of getKeys(item)">
                                                <div *ngIf="sub.endsWith('_BOTTOM')" class="infoBar col-lg-2">
                                                    <span class="infoVendor">{{getOriginalFieldName(sub)}}</span>
                                                    <span class="infoTitle">{{item[sub]}}</span>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <!-- <div class="reviewSection">
                                            <div class="buyerDrop">
                                                <div class="infoBar">
                                                    <span class="infoVendor">VENDOR NAME</span>
                                                    <span class="infoTitle">TDN Enterprises Pvt Ltd</span>
                                                </div>
                                            </div>
                                            <div class="buyerDropDetails">
                                                <div class="infoBar">
                                                    <span class="infoVendor">VENDOR CODE</span>
                                                    <span class="infoTitle">RT230987</span>
                                                </div>
                                                <div class="infoBar">
                                                    <span class="infoVendor">CREATED ON</span>
                                                    <span class="infoTitle">12 April 2023</span>
                                                </div>
                                                <div class="infoBar">
                                                    <span class="infoVendor">COMPANY TYPE</span>
                                                    <span class="infoTitle">Medium</span>
                                                </div>
                                                <div class="infoBar">
                                                    <span class="infoVendor">PO NUMBER</span>
                                                    <span class="infoTitle">987002300</span>
                                                </div>
                                                <div class="infoBar">
                                                    <span class="infoVendor">PAYMENT TERMS</span>
                                                    <span class="infoTitle">EMI</span>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                                <!-- <ng-container *ngFor="let item of lstTransaction;let rowIndex=index">
                                    <div class="mail-box-info-row"
                                        [style.border-left-color]="(item.Priority|lowercase)=='normal'?'#3bb54a':(item.Priority|lowercase)=='medium'?'orange':'red'"
                                        *ngIf="(rowIndex >= (recordsPerPage*(currentPage-1))) && (rowIndex < (recordsPerPage*currentPage))">
                                        <div class="mail-box-info-left">
                                            <a href="javascript:void(0)" class="mail-edit-icon"
                                                (click)="openTransactionModal(item.DOCUMENT_DETAIL_ID)">
                                                <i class="material-icons">edit</i>
                                            </a>
                                            <h5 class="modal-trigger"
                                                (click)="openTransactionModal(item.DOCUMENT_DETAIL_ID)">{{item.URN}}
                                            </h5>
                                            <p class="description-mail">Queue: {{item.Queue}}</p>
                                            <p class="description-mail" [(title)]="item['Work Item Type']">Work Item
                                                Type: {{item['Work Item Type']}}</p>
                                        </div>
                                        <div class="mail-box-info-center">
                                            <p class="description-mail">Created On: {{item['Created Date']}}</p>
                                            <p class="description-mail">Source: {{item.SOURCE}}</p>
                                            <p class="description-mail" [(title)]="item['Pending With']">Pending With:
                                                {{item['Pending With']}} </p>
                                        </div>
                                        <div class="mail-box-info-right">
                                            <h6 class="mail-id">{{item['Work List']}}</h6>
                                            <p class="mail-time">Pending For: {{item['Pending Since (Days)']}} Days
                                            </p>
                                            <ul class="single-mail-action-list">
                                                <li>
                                                    <i class="material-icons download_icon"
                                                        (click)="commonService.openAttachment(item.URN,'')">file_download</i>
                                                </li>
                                                <li><img
                                                        src="/assets/img/icons/{{item.Priority|lowercase}}_priority.png">
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container> -->
                            </div>
                            <!-- Pagination Bottom -->
                            <div class="dataTables_paginate paging_simple_numbers" id="example_paginate">
                                <div class="paginate_left_sec">
                                    <div class="dataTables_info" id="example_info" role="status" aria-live="polite">
                                        Showing {{firstRecord}} to {{lastRecord}} of {{this.lstTransaction.length}}
                                        entries
                                        <span> | Records Per Page
                                            <a [matMenuTriggerFor]="recordsPerPageMenu"
                                                class="record_per_page_trigger">{{recordsPerPage}}</a></span>
                                        <mat-menu #recordsPerPageMenu="matMenu">
                                            <ul class="record_per_page_menu">
                                                <li *ngFor="let r of lstRecordsPerPage"
                                                    (click)="recordsPerPage=r;changeRecordsPerPage()">{{r}}
                                                </li>
                                            </ul>
                                        </mat-menu>
                                    </div>

                                </div>
                                <div class="paginate_right_sec">
                                    <a class="paginate_button previous disabled" aria-controls="example" data-dt-idx="0"
                                        tabindex="0" id="example_previous" (click)="changePage('prev',0)">
                                        <i class="material-icons">chevron_left</i>
                                    </a>
                                    <span>
                                        <a *ngFor="let pg of lstTotalPage;let i=index;" class="paginate_button"
                                            [class.current]="currentPage==(i+1)" aria-controls="example" data-dt-idx="1"
                                            tabindex="0" (click)="changePage('',(i+1))">{{i+1}}</a>
                                    </span>
                                    <a class="paginate_button next" aria-controls="example" data-dt-idx="4" tabindex="0"
                                        id="example_next" (click)="changePage('next',0)">
                                        <i class="material-icons">chevron_right</i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-transaction-lite (reloadPage)="reloadDashboard($event)"></app-transaction-lite>


<ng-template #filterOptionModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Filter Options</h5>
            <div>
                <button type="button" class="model_ok_btn"
                    (click)="getWorkListWithCount();getWorkItems();modal.dismiss('Load click');">Load</button>
                <button type="button" class="model_cancle_btn" (click)="modal.dismiss('Cross click')">Close</button>
            </div>
        </div>
        <div class="modal-body">
            <div class="row">
                <!-- <mat-checkbox class="chk-filter-persona" [(ngModel)]="saveAsDefaultFilter"
                        (click)="$event.stopPropagation();">
                        Save as default
                    </mat-checkbox> -->
                <div class="col-lg-12">
                    <span class="bx-sub-title">Work Item Type</span>
                    <ul class="selection-list row">
                        <li class="col-lg-6" *ngFor="let doc of docTypeList"
                            [class.selected]="selectedDocumentType.docTypeId==doc.docTypeId"
                            (click)="onSelectDocType(doc)">
                            <div class="selected-check">{{doc.docTypeName}}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row advance-search-wrp">
                <div [formGroup]="frmFilterSearch" *ngIf="frmFilterSearch">
                    <div class="row">
                        <div class="bx-sub-title">Search</div>
                        <div *ngFor="let field of advanceSearchFields" [ngSwitch]="field.control_type|lowercase"
                            class="col-lg-{{field.control_type=='TEXTAREA'?6:3}}">

                            <mat-form-field *ngSwitchCase="'textbox'" [style.width.%]="100">

                                <input matInput [type]="field.value_type" [placeholder]="field.field_name"
                                    [formControlName]="field.db_column_name"
                                    [class.text-end]="field.value_type=='number'" (change)="onTextChange(field);" />

                                <button *ngIf="hasValue(field)" mat-button matSuffix mat-icon-button
                                    (click)="clearText(field)">
                                    <mat-icon>clear</mat-icon>
                                </button>
                            </mat-form-field>

                            <mat-form-field appearance="legacy" *ngSwitchCase="'dropdown'" [style.width.%]="100">
                                <mat-label for="{field.field_name}">{{field.field_name}}</mat-label>
                                <mat-select [formControlName]="field.db_column_name" (click)="searchText.focus()"
                                    (focus)="searchText.focus()" (closed)="searchText.value=''" [id]="field.field_name">
                                    <input type="search" (keydown)="$event.stopPropagation()" #searchText
                                        autocomplete="off" class="mat-select-search"
                                        placeholder="Search {{field.field_name}}">
                                    <mat-option [value]="option.id"
                                        *ngFor="let option of field.options| listFilter:{'name':searchText.value}">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                                <button *ngIf="field.is_magnify_search==1" mat-button matSuffix mat-icon-button
                                    (click)="$event.stopPropagation();openFilterFieldMagnifySearchModal(field.field_mapping_detail_id,field.magnify_dependant_fields)">
                                    <mat-icon>search</mat-icon>
                                </button>
                            </mat-form-field>

                            <mat-form-field *ngSwitchCase="'date'" [style.width.%]="100">
                                <input matInput readonly [formControlName]="field.db_column_name"
                                    [matDatepicker]="picker" [placeholder]="field.field_name">
                                <button *ngIf="hasValue(field)" mat-button matSuffix mat-icon-button
                                    (click)="clearText(field)">
                                    <mat-icon>clear</mat-icon>
                                </button>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>

                            <mat-form-field *ngSwitchCase="'textarea'" [style.width.%]="100">
                                <textarea matInput [placeholder]="field.field_name"
                                    [formControlName]="field.db_column_name" rows="1"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>